import React from 'react';

export const useNoOutlineWrapper = (testId: string, isWeb: boolean) => {
  const wrapWithNoOutline = (component: React.ReactElement) => {
    if (!isWeb) {
      return component;
    }

    const handleWrapperClick = (event: React.MouseEvent) => {
      event.stopPropagation();
    };

    const noOutlineStyles = `
      [data-testid="${testId}"], 
      [data-testid="${testId}"] *,
      [data-testid="${testId}"] .MuiButton-root {
        outline: none !important;
        border: none !important;
        box-shadow: none !important;
        background-color: transparent !important;
      }
    `;

    return React.createElement(
      'div',
      {
        onClick: handleWrapperClick,
        style: {
          display: 'inline-block',
          WebkitTapHighlightColor: 'transparent',
        },
      },
      React.createElement('style', {}, noOutlineStyles),
      component,
    );
  };

  return { wrapWithNoOutline };
};
